import L from "leaflet";
import { pointInLayer } from "leaflet-pip";

export const convertCoordinates = (lon, lat) => {
  var x = (lon * 20037508.34) / 180;
  var y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
  y = (y * 20037508.34) / 180;
  return [x, y];
};

export const convertCoordinates2 = (arr) => {
  console.log(arr);
  const [lon, lat] = arr;
  var x = (lon * 20037508.34) / 180;
  var y = Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
  y = (y * 20037508.34) / 180;
  return [x, y];
};

export function isMarkerWithinArabBoundries(marker) {
  //TODO change to actual arab coordinates
  const ARAB_GEO = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {},
        geometry: {
          coordinates: [
            [
              [-34.216653178019214, 37.092560893897954],
              [-34.216653178019214, 8.682128405740343],
              [59.59563227938659, 8.682128405740343],
              [59.59563227938659, 37.092560893897954],
              [-34.216653178019214, 37.092560893897954],
            ],
          ],
          type: "Polygon",
        },
      },
    ],
  };

  // create the first polygon
  const arab_geo = L.geoJSON(ARAB_GEO);
  return pointInLayer(marker.getLatLng(), arab_geo).length > 0;
}
